import * as React from 'react';
import * as I18n from 'i18n-js';

import SiteModule from '@reverbdotcom/commons/dist/components/site_module';
import FormGroup from '@reverbdotcom/commons/dist/components/form_group';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';
import LabelTag from '@reverbdotcom/commons/dist/components/label_tag';
import experiments from '@reverbdotcom/commons/dist/experiments';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import { useViewTracking } from '@reverbdotcom/commons/dist/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';

import URLHelpers from '../../shared/url_helpers';

interface IProps {
  prefersReverbShippingLabel: boolean;
}

function RSLSelectorFooterModule() {
  return (
    <ul className="rsl-selector-module__list-group">
      <li className="rsl-selector-module__list-item">
        {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.savePrice')}
      </li>
      <li className="rsl-selector-module__list-item">
        <SanitizedRender
          htmlTag="div"
          html={I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.safeShipping',
            {
              linkOpen: `<a href=${URLHelpers.sellingSafeShippingInfoPath} target="_blank">`,
              linkClose: '</a>',
            },
          )}
        />
      </li>
      <li className="rsl-selector-module__list-item">
        {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.printLabel')}
      </li>
    </ul>
  );
}

export const COMPONENT_NAME = 'ReverbShippingLabelSelector';

export default function ReverbShippingLabelSelector({ prefersReverbShippingLabel = true }: IProps) {

  const [prefersRSL, setPrefersRSL] = React.useState(prefersReverbShippingLabel);
  const user = useUser();
  const mParticleViewData = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.RSL_PREFERRED_UI,
    ]),
  };

  useViewTracking(mParticleViewData, true);

  function handleToggle() {
    setPrefersRSL(!prefersRSL);
  }

  if (!isExperimentEnabled(user, experiments.RSL_PREFERRED_UI)) {
    return null;
  }

  return (
    <>
      <FormGroup
        label={I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.title')}
      >
        <SiteModule footerContent={RSLSelectorFooterModule()}>
          <div className="label-with-radio">
            <input
              onChange={() => handleToggle()}
              type="radio"
              name="product[prefers_reverb_shipping_label]"
              id="rsl-radio"
              checked={prefersRSL}
              value="1"
              required
            />
            <label className="size-110" htmlFor="rsl-radio">
              <span className="mr-1">
                {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.revebShippingLabel')}
              </span>
              <LabelTag color="blue">
                {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.tag')}
              </LabelTag>
            </label>
            <p className="rsl-selector-module__help-text">
              {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.helpText')}
            </p>
          </div>
        </SiteModule>
        <SiteModule>
          <div className="label-with-radio">
            <input
              onChange={() => handleToggle()}
              type="radio"
              name="product[prefers_reverb_shipping_label]"
              id="custom-label-radio"
              checked={!prefersRSL}
              value="0"
              required
            />
            <label className="size-110" htmlFor="custom-label-radio">
              {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.customLabel')}
            </label>
          </div>
        </SiteModule>
      </FormGroup>
    </>
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/shipping_labels/reverb_shipping_label_selector.tsx